import React, {useState} from "react";
import {AiOutlineUser} from "react-icons/ai";
import {IoKeySharp} from "react-icons/io5";
import {Alert, Form, Input} from 'antd';
import {useDispatch} from 'react-redux';

import classes from './GetRestorableAccount.module.scss'
import axios from '../../../../services/axios'
import {setMessage} from "../../../../store/actions";

import PasswordRecoveryWrapper from "../PasswordRecoveryWrapper";
import SubmitButton from "../../../UI/SubmitButton/SubmitButton";
import {renderToString} from 'react-dom/server';
import {recoveryMethods} from "../ChooseRecoveryMethod/ChooseRecoveryMethod";


const GetRestorableAccount = (props) => {
    const [login, setLogin] = useState('')
    const [loading, setLoading] = useState(false)
    const [ifError, setIfError] = useState(false)
    const [ifUnmount, setIfUnmount] = useState(false)

    const dispatch = useDispatch()

    const setContainerStylesOnUnmount = () => {
        if (ifUnmount) return { opacity: 0, transform: 'translateY(20px)' }
        else return { opacity: 1, transform: 'translateY(0)' }
    }

    const handleSubmit = () => {
        setIfError(false)
        setLoading(true)
        axios.get(`/api/v1/settings/masked-contacts?login=${login}`)
            .then((response) => submitLoginSuccess(response))
            .catch((error) => submitLoginError(error))
    }

    const submitLoginSuccess = (response) => {
        setLoading(false)
        setIfUnmount(true)
        setTimeout(() => {
            const isEmployee = response.data.employee;
            if (!isEmployee) {
                props.history.push({
                    pathname: "/password-recovery/contacts",
                    state: {
                        contacts: response.data.contacts,
                        login: login,
                        numberOfAttempts: response.data.remainingAttempts
                    }
                })
            } else {
                const employeeContact = response.data.contacts[0];
                const contact = { ...employeeContact, ...recoveryMethods.find(r => r.typeId === employeeContact.contactTypeId) }
                props.history.push({
                    pathname: "/password-recovery/mask",
                    state: {
                        contact: { ...contact, icon: renderToString(contact.icon) },
                        login: login
                    }
                })
            }
        }, 400);

    }

    const submitLoginError = (error) => {
        setLoading(false)
        switch (error.response.status) {
            case 404:
                setIfError(true)
                break;
            case 429:
                setIfUnmount(true)
                setTimeout(() => {
                    props.history.push({ pathname: "/password-recovery/error", state: { time: error.response.data.banExpiredTime } })
                }, 400);
                break;
            default:
                dispatch(setMessage({ type: 'warning', text: "Не удалось подключиться к серверу." }))
        }
    }

    return (
        <PasswordRecoveryWrapper icon={<IoKeySharp size={35} />} title="Восстановление пароля">
            <div className={classes.container}
                style={setContainerStylesOnUnmount()}>
                <Form
                    name="password_recovery"
                    scrollToFirstError={true}
                    onFinish={handleSubmit}
                    className="GetRestorableAccount_formContainer">
                    <Form.Item>
                        <div className={classes.extra}>Для восстановления пароля введите логин, используемый для входа</div>
                    </Form.Item>
                    <Form.Item
                        name="login"
                        hasFeedback={true}
                        rules={[
                            { required: true, message: 'Данное поле является обязательным!' },
                            {
                                pattern: /^[a-zA-Z0-9_\-.]+$/g,
                                message: 'Некорректный формат логина'
                            }
                        ]}>
                        <Input
                            prefix={<AiOutlineUser />}
                            placeholder="Логин"
                            value={login}
                            onChange={(e) => setLogin(e.target.value.trim())} />
                    </Form.Item>
                    <Form.Item>
                        <SubmitButton
                            type="submit"
                            text="Отправить"
                            block
                            loading={loading}
                        />
                    </Form.Item>

                    {(ifError) && <Form.Item>
                        <Alert
                            message="Ошибка!"
                            description="Не удалось найти учетную запись."
                            type="error"
                            showIcon
                            className={classes.errorContainer}
                        />
                    </Form.Item>}
                </Form>
            </div>
        </PasswordRecoveryWrapper>
    )
}

export default GetRestorableAccount;